// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerProjectDrawer_container__r2a6U","dropdownAddButton":"CustomerProjectDrawer_dropdownAddButton__O7mhh"};